import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { isMobile, isSafari } from "react-device-detect";
import "./assets/css/App.css";
import Navigator from "./navigation";
import packageJson from "../package.json";
import { setPlayer } from "./store/actions/player";
import { persistor } from "./store";
import { SET_PLAYER } from "./store/actions/constants";
import { Footer, Header } from "./parts";
import { Player } from "./components";
import { MobileBanner } from "./components";

const App = () => {
	const dispatch = useDispatch();
	const [isBannerOpened, setIsBannerOpened] = useState(false);
	const version = localStorage.getItem("version");
	const lastRadioListenedRpId = localStorage.getItem("lastRadioListened");
	function resetStore() {
		persistor.purge();
		dispatch({
			type: SET_PLAYER,
			payload: {},
		});
	}
	useEffect(() => {
		if (isMobile) {
			setIsBannerOpened(true);
		}
	}, []);
	const caching = () => {
		if (version !== packageJson.version) {
			localStorage.setItem("lastRadioListened", "");
			resetStore();
			if ("caches" in window) {
				caches.keys().then((names) => {
					names.forEach((name) => {
						caches.delete(name);
					});
				});

				window.location.reload(true);
			}
			localStorage.clear();
			localStorage.setItem("version", packageJson.version);
		}
	};

	const getLastRadioListened = () => {
		dispatch(setPlayer({ playing: false }));
		if (lastRadioListenedRpId) {
			document.querySelector(".playerContainer").style.bottom = "0px";
		} else if (!lastRadioListenedRpId) {
			document.querySelector(".playerContainer").style.bottom = "-100px";
		}
	};

	window.onload = () => {
		caching();
		getLastRadioListened();
	};

	return (
		<div className="App">
			{isMobile && isBannerOpened && !isSafari ? <MobileBanner setIsBannerOpened={setIsBannerOpened} /> : null}
			<Header isBannerOpened={isBannerOpened} />
			<Navigator />
			<Footer />
			<Player />
		</div>
	);
};

export default App;
